import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import './HandbookModal.css'; // Minimal styles
import { handbookStructure, contentMap } from '../../docs/handbookStructure';

const HandbookModal = ({ isOpen, onClose, initialSection = 'overview' }) => {
    const [currentSlug, setCurrentSlug] = useState(initialSection);

    useEffect(() => {
        if (isOpen && initialSection) {
            setCurrentSlug(initialSection);
        }
    }, [isOpen, initialSection]);

    if (!isOpen) return null;

    const currentContent = contentMap[currentSlug] || contentMap['overview'];

    // Render Sidebar Item
    const renderSidebarItem = (item) => {
        const isActive = currentSlug === item.slug;
        const className = `handbook-sidebar-item ${isActive ? 'active' : ''}`;

        return (
            <div
                key={item.slug || item.title}
                className={className}
                onClick={() => item.slug && setCurrentSlug(item.slug)}
            >
                {item.icon && <span className="icon">{item.icon}</span>}
                <span className="title">{item.title}</span>
            </div>
        );
    };

    return (
        <div className="handbook-overlay" onClick={onClose}>
            <div className="handbook-modal" onClick={e => e.stopPropagation()}>
                <div className="handbook-sidebar">
                    <div className="handbook-header">
                        <h2>📘 PIM Handbook</h2>
                    </div>
                    <div className="handbook-nav">
                        {handbookStructure.map((section, idx) => (
                            <div key={idx} className="handbook-section">
                                {section.slug ? (
                                    renderSidebarItem(section)
                                ) : (
                                    <>
                                        <h3 className="section-title">{section.title}</h3>
                                        {section.items.map(sub => renderSidebarItem(sub))}
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="handbook-content">
                    <button className="close-btn" onClick={onClose}>✕</button>
                    <div className="markdown-body">
                        <ReactMarkdown>{currentContent}</ReactMarkdown>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HandbookModal;
